/* eslint-disable import/no-cycle */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Context as StoreUserContext } from '../../../../../providers/StoreUserContextProvider';
import WsProductCard from '../../sections/productGrid/WsProductCard';
import { getSelectedResourceBaseNavigationUrl } from '../../../../../helpers/webstoreHelper';

const WsProductBlock = ({
  themeConfig,
  config,
  colorScheme,
  onNavigate,
  baseStoreUrl,
  resourceNavigation
}) => {
  const { state } = useContext(StoreUserContext);
  const ecomStoreProduct = state.ecomStoreProductHistory.value.find(
    (c) => c.uuid === config.ecomStoreProduct
  );
  const productNotFound = state.ecomStoreProductHistory.uuidsNotFound.includes(
    config.ecomStoreProduct
  );
  const baseResourceUrl = `${baseStoreUrl}${getSelectedResourceBaseNavigationUrl(
    resourceNavigation,
    'products'
  )}`;

  return (
    <WsProductCard
      baseStoreUrl={baseResourceUrl}
      colorScheme={colorScheme}
      ecomStoreProduct={ecomStoreProduct}
      hideAllProductBadges={themeConfig?.hideAllProductBadges === 'true'}
      hideFreeShippingBadge={themeConfig?.hideFreeShippingBadge === 'true'}
      noProduct={!config.ecomStoreProduct || productNotFound}
      onNavigate={onNavigate}
      showSecondImageOnHover={config.showSecondImageOnHover === 'true'}
      showVendorName={config.showVendorName === 'true'}
    />
  );
};

WsProductBlock.propTypes = {
  baseStoreUrl: PropTypes.string,
  colorScheme: PropTypes.object,
  config: PropTypes.object,
  onNavigate: PropTypes.func,
  resourceNavigation: PropTypes.array,
  themeConfig: PropTypes.object
};

export default WsProductBlock;
